// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"101":"0aeecfea","284":"ec19be46","378":"2ebe36dc","415":"bbbc1a65","424":"7ae81b6a","598":"279a1e44","736":"5409095f","787":"33e2ad3f","878":"12451c23","930":"a7526009","942":"e3c1c0bf"}[chunkId] + ".js";
};